// extracted by mini-css-extract-plugin
module.exports = {"root":"styles-module--root--1hO-d"};